import { CommunityDetailsSection, StandardLabelsSection } from '@communities/content-management/components';
import { PromptsSection } from '@communities/prompt-management/components';
import { withAppInsightsTracking } from '@core/logging/withAppInsightsTracking';
import { Section } from '@soteria/design-system-ve';

interface CommunityContextTabProps {
  entityId: string;
  isEntityAdmin: boolean;
  onEditCommunity?: () => void;
}

function CommunityContextTabComponent({ entityId, isEntityAdmin, onEditCommunity }: CommunityContextTabProps) {
  return (
    <>
      {/* Community Details Section */}
      <Section spacing="medium">
        <CommunityDetailsSection onEditCommunity={isEntityAdmin ? onEditCommunity : undefined} />
      </Section>

      {/* Standard Labels Section */}
      <Section spacing="medium">
        <StandardLabelsSection />
      </Section>

      {/* Prompts Section - Only for Communities and Admins */}
      {isEntityAdmin && (
        <Section spacing="medium">
          <PromptsSection communityId={entityId} isCommunityAdmin={isEntityAdmin} />
        </Section>
      )}
    </>
  );
}

export const CommunityContextTab = withAppInsightsTracking(CommunityContextTabComponent, 'CommunityContextTab');
